import { Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';

export const Title = () => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Updates);
  const isDesktop = useIsDesktop();

  return (
    <Stack>
      <Stack gap={isDesktop ? '16px' : '8px'}>
        <Typography
          mt={isDesktop ? undefined : 2}
          variant={'h2'}
          color={'text.secondary'}
          component={'h1'}
        >
          {dictionary.title}
        </Typography>
        <Typography variant={'body3'} color={'text.secondary'}>
          {dictionary.subtitle}
        </Typography>
      </Stack>
    </Stack>
  );
};
